const string = {

    data() {
        return {

        }
    },
    methods: {

        slugfy(text) {
            return text
                .toString()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim()
                .replace(/\s+/g, '-')
                .replace(/[^\w-]+/g, '')
                .replace(/--+/g, '-')
        }
    }
}

export default string


// WEBPACK FOOTER //
// ./src/mixins/string.js